import {Button, Col, Divider, Modal, Popconfirm, Row, Select, Spin, Tabs, Typography} from "antd";
import HecRasProject from "../Components/HecRasProject";
import BaseLayout from "../Components/layout/layout-with-sider/BaseLayout";
import {useProject} from "../Context/ProjectContext";
import ProjectUploader from "../Components/ProjectUploader";
import md5 from 'md5-hash'
import ApiService from "../Service/ApiService";
import {useEffect, useState} from "react";
import ProjectMD5 from "../Helpers/ProjectMD5";
import './project-comparer.css'
import SampleProjectModal from "../Components/SampleProjectModal";
import HecRasHelper from "../Helpers/HecRasHelper";
import YoutubeComponent from "../Components/YoutubeComponent";
import DeckRoadwayEditor from "../Components/Output/UI/DeckRoadwayEditor";
export default function ProjectComparer()
{
    const {baseProject, compareProject, setCompareProject, setBaseProject, removeBaseProject, removeCompareProject} = useProject()
    const [projectModal, setProjectModal] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [spinner2, setSpinner2] = useState(false)
    const [tutorial, setTutorial] = useState(false)



    useEffect(() => {
        if(localStorage.getItem('show-tutorial') === 'show-tutorial') {
            setTutorial(true)
        }
    }, [])

    const onUploadLeft = async (project) => {
        try {
            setSpinner(true)

            for (const file of project.projectFiles) {
                file.csList = HecRasHelper.parseCSListFromGeoFile({
                    geoFile: file.geometry.text
                })
            }

            if(project?.information?.hasOutputFile === 'false') {
                project.projectFiles = project.projectFiles.map(x => {
                    x.mapProfiles = []
                    x.mappedProfiles = []
                    return x
                })
            }
            let data = project?.projectFiles?.map(prj => {
                return {
                    projectTitle: project.information.title,
                    flowTitle: prj.flow.title,
                    planTitle: prj.plan.title,
                    geometryTitle: prj.geometry.title,
                    projectHash: prj.projectHash
                }
            })

            const res = await ApiService.UserProject.UploadProject(data);
            setSpinner(false)
            if(res.success) {
                setBaseProject(project)
            }
        } catch (exp) {
            setSpinner(false)
            console.log('Project Upload: ',exp)
        }
    }

    const onUploadRight = async (project) => {
        try {
            setSpinner2(true)
            for (const file of project.projectFiles) {
                file.csList = HecRasHelper.parseCSListFromGeoFile({
                    geoFile: file.geometry.text
                })
            }

            if(project?.information?.hasOutputFile === 'false') {
                project.projectFiles = project?.projectFiles.map(x => {
                    x.mapProfiles = []
                    x.mappedProfiles = []
                    return x
                })
            }
            let data = project?.projectFiles?.map(prj => {
                return {
                    projectTitle: project.information.title,
                    flowTitle: prj.flow.title,
                    planTitle: prj.plan.title,
                    geometryTitle: prj.geometry.title,
                    projectHash: prj.projectHash
                }
            })


            const res = await ApiService.UserProject.UploadProject(data);
            setSpinner2(false)
            if(res.success) {
                setCompareProject(project)
            }
        }
        catch (e) {
            setSpinner(false)
        }
    }

    return (
        <>
            <BaseLayout>
                <Row gutter={[24,24]}>
                    <Col xs={24} xl={24}>
                        <div
                            className={'project-warning'}
                            onClick={() => {
                                setProjectModal(true)
                            }}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 16,
                                backgroundColor: '#E2F0D9',
                                border: '1px solid #70AD47',
                                padding: 8, width: '100%',
                                textAlign: 'left',
                                cursor: 'pointer'
                            }}
                        >
                            <br/>
                            <p style={{margin: 0}}>
                                Don't you have a one-dimensional HEC-RAS model to test at hand?
                                <br/>
                                No worries! Click here to select from the test models.
                            </p>
                            <br/>
                        </div>
                    </Col>
                </Row>
                <br/>
                <Row gutter={[24,24]}>
                    <Col xs={24} xl={12}>
                        <Typography.Title level={5}>Model A</Typography.Title>
                        <div>
                            {
                                !baseProject.information.title && (
                                    <ProjectUploader
                                        onUploadProject={onUploadLeft}
                                    />
                                )
                            }
                            {
                                spinner && (
                                    <div style={{marginTop: 16}}>
                                        <Spin />
                                    </div>
                                )
                            }
                            {
                                !spinner && (
                                    <HecRasProject
                                        project={baseProject}
                                        onProjectChanged={(prj) => setBaseProject({
                                            ...prj,
                                        })}
                                        onRemoved={() => {removeBaseProject()}}
                                    />
                                )
                            }
                        </div>
                    </Col>
                    <Col xs={24} xl={12}>
                        <Typography.Title level={5}>Model B</Typography.Title>
                        <div>
                            {
                                !compareProject.information.title && (
                                    <ProjectUploader
                                        onUploadProject={onUploadRight}
                                    />
                                )
                            }
                            {
                                spinner2 && (
                                    <div style={{marginTop: 16}}>
                                        <Spin />
                                    </div>
                                )
                            }
                            {
                                !spinner2 && (
                                    <HecRasProject
                                        project={compareProject}
                                        onProjectChanged={(prj) => setCompareProject({
                                            ...prj,
                                        })}
                                        onRemoved={() => {removeCompareProject()}}
                                    />
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </BaseLayout>
            <SampleProjectModal
                open={projectModal}
                onCancel={() => {setProjectModal(false)}}
                onOk={async (modelA, modelB) => {
                    setProjectModal(false)

                    if(modelA) {
                        await onUploadLeft(modelA)
                    }

                    if(modelB) {
                        await onUploadRight(modelB)
                    }
                }}
            />
            <Modal
                title="RAS Review Tutorial"
                open={tutorial} footer={(<div />)}
                onCancel={() => {
                    setTutorial(false)
                    document.getElementById('yt-tutorial-frame').removeChild(
                        document.getElementById('yt-tutorial-frame-player')
                    )
                }}
                width={720}
            >
                <div>
                    <YoutubeComponent
                        _id={'yt-tutorial-frame'}
                        width={640}
                        height={480}
                        speed={1.5}
                        src={'https://www.youtube.com/embed/0oQZS-b8jXk'}
                    />
                    <Popconfirm
                        title="You can watch this video later in `How To` menu. Do you want to proceed?"
                        description="You can watch this video later in `How To` menu."
                        onConfirm={() => {
                            const res = ApiService.User.UpdateUserDontShow(true)
                            setTutorial(false)
                            localStorage.removeItem('show-tutorial')
                            document.getElementById('yt-tutorial-frame').removeChild(
                                document.getElementById('yt-tutorial-frame-player')
                            )
                        }}
                        onCancel={() => {}}
                        okText="Okay"
                        cancelText="Cancel"
                    >
                        <Button
                            type={'ghost'}
                        >
                            Dont`t show again
                        </Button>
                    </Popconfirm>
                </div>
            </Modal>
        </>
    )
}
